<template>
  <div class="table-container">
    <el-table
            :data="achievements"
            v-loading="isLoading"
            size="small"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="expand-column">
            <div><label>成果主要应用行业: </label><span>{{props.row.industries}}</span></div>
            <div><label>知识产权及获奖情况: </label><span>{{props.row.credit}}</span></div>
            <div><label>成果形式: </label><span>{{props.row.forms}}</span></div>
            <div><label>成果所处阶段: </label><span>{{props.row.stages}}</span></div>
            <div><label>合作意向: </label><span>{{props.row.cooperation_intentions}}</span></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              prop="year"
              label="年份"
              width="60px"
      >
      </el-table-column>
      <el-table-column
              prop="name"
              label="名称"
              show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
              prop="college"
              label="院系"
              show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
              prop="director"
              label="负责人"
              show-overflow-tooltip
              width="140"
      >
        <template slot-scope="props">
          {{props.row.director}} [{{props.row.director_title}}]
        </template>
      </el-table-column>
      <el-table-column
              prop="field"
              label="研究方向"
              width="260"
      >
      </el-table-column>
      <el-table-column
              prop="created_at"
              width="160"
              label="创建时间"
              align="center"
              :formatter="unixFormatter"
      ></el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              width="140"
      >
        <template slot-scope="scope">
          <el-button
                  @click="edit(scope.row)"
                  type="text"
                  size="mini"
          >编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <ox-safe-button
                  @confirm="remove(scope.row)"
                  type="text"
                  size="small"
          >删除</ox-safe-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
              background
              layout="prev, pager, next"
              @current-change="onPageChange"
              :page-size="pagination.size"
              :current-page="pagination.current"
              :total="pagination.total"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
    import { pageMixin, fmtMixin } from "@/ox/Mixins";
    import OxSafeButton from '@/ox/components/OxSafeButton';

    export default {
        name: "AchievementTable",
        mixins: [pageMixin, fmtMixin],
        components:{
            OxSafeButton
        },
        data: function() {
            return {
                page: 1,
                isLoading: false,
                achievements: []
            };
        },

        mounted() {
            this.loadData(1);
        },
        methods: {
            loadData(page) {
                this.isLoading = true;
                const currentPage = page || this.page;
                const query = new window.BaaS.Query();
                const {filter} = this.$parent;
                if(filter.director){
                    query.compare('director', '=', filter.director);
                }
                if(filter.college){
                    query.compare('college', '=', filter.college);
                }
                if(filter.field){
                    query.compare('field', '=', filter.field);
                }
                if(filter.keyword){
                    query.contains('name', filter.keyword);
                }
                this.$ox
                    .service("achievement")
                    .find(query, {
                        page: currentPage,
                        withCount: true,
                        orderBy: ["-updated_at"]
                    })
                    .then(res => {
                        this.isLoading = false;
                        this.pagination.size = res.meta.limit;
                        this.pagination.total = res.meta.total_count;
                        this.pagination.current = currentPage;
                        this.page = currentPage;
                        this.achievements = res.objects;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            onPageChange(page) {
                this.loadData(page);
            },
            edit(row) {
                this.$parent.$refs.dialog.show(row)
            },
            remove(row){
                this.$ox.service('achievement').delete(row.id).then(()=>{
                    this.specialists = this.specialists.filter(specialist=>specialist.id!==row.id)
                    this.$notify.success({
                        title: '操作成功',
                        message: `成果"${row.name}"信息已删除`
                    });
                })
            }
        }
    };
</script>

<style scoped>
    .name{
        display: flex;
        justify-content:flex-start;
        align-items:center;
    }
    .expand-column label{
        width:140px;
        text-align:right;
        margin-right: 10px;
    }
    .name .el-image{
        width:32px;
        height:32px;
        margin-right:10px;
        text-align: center;
    }
    .name .el-avatar{
        margin-right:10px;
    }
    .name img{
        border-radius: 6px;
    }
</style>
